import { Breadcrumbs, Typography, Link as MuiLink } from '@mui/material';
import { Link } from 'react-router-dom';
import { NavigateNext as NavigateNextIcon } from '@mui/icons-material';

interface BreadcrumbsNavProps {
  toolName: string;
  category: string;
}

export default function BreadcrumbsNav({ toolName, category }: BreadcrumbsNavProps) {
  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      sx={{ mb: 1, mt: 1, ml: { xs: 2, sm: 3 } }}
    >
      <MuiLink
        component={Link}
        to="/"
        underline="hover"
        color="text.secondary"
        sx={{ fontSize: '0.85rem' }}
      >
        Home
      </MuiLink>
      <Typography color="text.secondary" sx={{ fontSize: '0.85rem' }}>
        {category}
      </Typography>
      <Typography color="text.primary" sx={{ fontSize: '0.85rem' }}>
        {toolName}
      </Typography>
    </Breadcrumbs>
  );
}
